import React from "react";
export function TableHead({ }) {
    return <thead>
        <tr>
            <th>
                <div className="parent-tag">
                    Date{' '}
                    <div className="filter-btn" style={{ cursor: 'pointer' }}>
                        <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z" fill="#77868B" />
                        </svg>
                        <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z" fill="#77868B" />
                        </svg>
                    </div>
                </div>
            </th>
            <th>Country</th>
            <th>Hash</th>
            <th>Wallet Address</th>
            <th>Project</th>
            <th>Credits Refunded</th>
            <th>Was Premium</th>
        </tr>
    </thead>;
}
